document.addEventListener('DOMContentLoaded', () => {
  const jdgmCarouselItemWrapper = document.querySelector(
    '.jdgm-carousel__item-wrapper',
  )

  const jdgmCarouselArrows = document.querySelector('.jdgm-carousel__arrows')

  if (!jdgmCarouselItemWrapper || !jdgmCarouselArrows) {
    return
  }

  const itemsCount = jdgmCarouselItemWrapper.childNodes.length

  const progressBarMarkup = `
    <div class="jdgm-carousel__progress-bar">
      <div class="jdgm-carousel__progress-bar-inner"></div>
    </div>
  `

  jdgmCarouselArrows.insertAdjacentHTML('afterbegin', progressBarMarkup)

  const progressBar = document.querySelector(
    '.jdgm-carousel__progress-bar-inner',
  )

  const updateProgressBar = (translateX) => {
    const itemWidth =
      jdgmCarouselItemWrapper.children[0]?.getBoundingClientRect().width || 0
    const currentSlideIndex = Math.round(Math.abs(translateX) / itemWidth) || 0

    progressBar?.style.setProperty('--jdgm-carousel-items-count', itemsCount)
    progressBar?.style.setProperty(
      '--jdgm-carousel-current-slide',
      currentSlideIndex,
    )
  }

  const wrapperMutationObserver = new MutationObserver((mutationsList) => {
    const { type, attributeName, target } = mutationsList[0] || {}

    if (type === 'attributes' && attributeName === 'style') {
      const currentStyle = target?.getAttribute('style')
      const translate3dRegex =
        /translate3d\((-?\d+)px,\s*(-?\d+)px,\s*(-?\d+)px\)/
      const [, translateX] = currentStyle?.match(translate3dRegex) || []

      if (translateX) {
        updateProgressBar(parseInt(translateX))
      }
    }
  })

  wrapperMutationObserver.observe(jdgmCarouselItemWrapper, {
    attributes: true,
    attributeFilter: ['style'],
  })

  updateProgressBar(0)
})
